import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { getResourceIcon } from "../../generic/icon/getResourceIcon";
import { Icon } from "../../generic/icon/Icon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var OfferRewardListItem = function (_a) {
    var reward = _a.reward, className = _a.className;
    var locaKey = reward.locaKey, amount = reward.amount;
    var icon = getResourceIcon(reward);
    var locaId = locaKey;
    if (reward.id === IdResource.Gold && !reward.buffAmount) {
        locaId = IdLoca.purchaseOffer_bonusGold;
    }
    if (reward.id === IdResource.Gold && reward.buffAmount) {
        locaId = IdLoca.offers_subscriptionBonus;
    }
    return (React.createElement("div", { className: IdStyles.OfferRewardListItem + " " + className },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
        React.createElement(TextLoca, { id: locaId, className: IdStyles.TextBoldPrimary }),
        React.createElement("div", { className: IdStyles.TextBoldAccent + " offer-reward-item__price" },
            React.createElement(NumberFormat, { amount: amount }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferRewardListItem.tsx
// module id = 2900
// module chunks = 3